import React, { ReactElement } from 'react';
import './KodanshaSubscription.scss';
// import KodanshaEmail from '../KodanshaUIKit/KodanshaEmail/KodanshaEmail';
// import KodanshaSubmit from '../KodanshaUIKit/KodanshaSubmit/KodanshaSubmit';
// import KodanshaArrow from '../KodanshaUIKit/KodanshaArrow/KodanshaArrow';
// import { useWindowSize } from '../Hooks/useWindowSize';

const KodanshaSubscription = (): ReactElement => {
    return (<div style={{marginTop: '80px'}}></div>
        /*<div className='subscription-background'>
            <div className='subscription-wrapper'>
                <h3 className='subscription-title'>Get the Latest News from Kodansha</h3>

                <div className='email-wrapper'>

                    <KodanshaEmail ariaLabel={'subscribe-to-email'} placeHolder='Enter you email'
                                   inputStyles='email-input' />


                    {width > 768 ? <KodanshaSubmit styles='direction' text='Sign Up' /> :
                        <KodanshaArrow text='Sign Up' />}

                    {/!*<KodanshaButton icon='Direction_No_Border' iconOrientation='0' styles='direction' size='30px'>Sign Up</KodanshaButton>*!/}
                </div>
            </div>
        </div>*/
    );
};

export default KodanshaSubscription;
